import { render } from "./CustomTemplate.vue?vue&type=template&id=31aaf1ea"
import script from "./CustomTemplate.vue?vue&type=script&lang=ts"
export * from "./CustomTemplate.vue?vue&type=script&lang=ts"
script.render = render

export default script